var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBottomArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 17,
    viewBox: "0 0 9 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.13317 8.49605L0.180283 15.8835C-0.0600852 16.1389 -0.0600853 16.5531 0.180283 16.8085C0.420723 17.0638 0.810442 17.0638 1.05085 16.8085L8.43901 8.95854C8.67935 8.70311 8.67935 8.289 8.43901 8.03357L1.05085 0.183622C0.806259 -0.0673606 0.416503 -0.0601547 0.180284 0.199722C-0.0501265 0.453235 -0.0501266 0.855123 0.180284 1.1086L7.13317 8.49605Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomArrow);
export default __webpack_public_path__ + "static/media/bottomArrow.b4bc6fddb18e7ad5ae70c11f1b4e2925.svg";
export { ForwardRef as ReactComponent };